import relatedProductsMapping from "./relatedProductsMapping";

const productRelatedProductsMapping = (data, display) => {
  if(display === 'related_products_one_of_each_category'){
    const groups = data.data.reduce((groups, item) => {
      const group = (groups[item.relationships?.field_product_category?.data?.tid[0]?.value] || []);
      group.push(item);
      groups[item.relationships?.field_product_category?.data?.tid[0]?.value] = group;
      return groups;
    }, []);

    let desiredItems = 3;
    let products = [];
    for (let item of groups){
      if(desiredItems > 0){
        if(item){
          products.push(item[0]);
          desiredItems--;
        }
      }
    }
    return relatedProductsMapping(products);
  } else {
    return relatedProductsMapping(data.data);
  }
};


export default productRelatedProductsMapping;
